import React from 'react'
import { Flex, Text, Separator, Popover } from 'components/ds'
import { useSelector } from 'react-redux'
import { getUser } from '@disco/state-management/selectors/user'
import { Link } from 'react-router-dom'
import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'
import styles from './switcher-popover-content.module.css'
import { SwitcherPopoverAvatar } from './switcher-popover-avatar'
import { SwitcherPopoverContentBusinesses } from './switcher-popover-content-businesses'
import { userBusinessesApi } from '@disco/state-management/ducks/businesses'
import { SwitcherPopoverContentLink } from './switcher-popover-content-link'
import apiClient from '@disco/api/server'
import { useNavigate } from 'react-router-dom'

export function SwitcherPopoverContent() {
  const user = useSelector(getUser)
  const location = useSelector(getLocationBeforeTransitions)
  const userBusinesses = userBusinessesApi.useGetUserBusinessesQuery()
  const navigate = useNavigate()

  if (!user?.business) {
    return null
  }

  const { name, image } = user.business
  const hasMultipleBusinesses = userBusinesses?.data?.length > 1

  return (
    <Flex direction="column" align="stretch" gap="2">
      <Popover.Close>
        <Link to="/" className={styles['switcher-popover-content-home-link']}>
          <Flex align="center">
            <SwitcherPopoverAvatar name={name} imageUrl={image} />
            <Flex direction="column" minWidth={'0'}>
              <Text
                size="2"
                className={
                  styles['switcher-popover-content-link-text-overflow']
                }
              >
                {user.first_name} {user.last_name}
              </Text>
              <Text
                size="1"
                color="gray"
                className={
                  styles['switcher-popover-content-link-text-overflow']
                }
              >
                {name}
              </Text>
            </Flex>
          </Flex>
        </Link>
      </Popover.Close>
      <SwitcherPopoverContentLink
        title="Settings and account"
        to="/settings"
        isSelected={location.pathname.startsWith('/settings')}
      />

      {hasMultipleBusinesses && (
        <>
          <Separator className={styles['switcher-popover-content-separator']} />
          <SwitcherPopoverContentBusinesses />
        </>
      )}
      <Separator className={styles['switcher-popover-content-separator']} />
      <SwitcherPopoverContentLink
        title={hasMultipleBusinesses ? 'Log out of all accounts' : 'Log out'}
        to={hasMultipleBusinesses ? undefined : '/logout'}
        textColor="red"
        testId="logout-option"
        onClick={
          hasMultipleBusinesses
            ? async () => {
                await apiClient.postUserLogoutAll()
                navigate('/logout')
              }
            : undefined
        }
      />
      <Separator className={styles['switcher-popover-content-separator']} />
      <Flex direction="column">
        <SwitcherPopoverContentLink
          title="Refer a friend"
          to="/referral-invite/send"
          isSelected={location.pathname.startsWith('/referral-invite/send')}
          className="hidden-phone"
        />
        <SwitcherPopoverContentLink
          title="Product changelog"
          href="https://disco.ac/changelog"
          isExternal
          hasExternalLinkIcon
        />
        <SwitcherPopoverContentLink
          title="Privacy policy"
          href="https://disco.ac/privacy"
          isExternal
          hasExternalLinkIcon
        />
      </Flex>
    </Flex>
  )
}
